// eslint-disable-next-line no-unused-vars
import { io } from 'socket.io-client'

class SocketioService {
  socket;
  URL = process.env.VUE_APP_SHELL_URL_SOCKET
  groupChatUnreadEvent = null
  groupChatUnreadHandler = null
  groupChatUnreadConnectHandler = null
  groupChatUnreadDisconnectHandler = null
  groupChatWasDisconnected = false

  setupSocketConnection () {
    if (this.socket) return this.socket

    this.socket = io(this.URL, {
      withCredentials: true
    })

    return this.socket
  }

  getPreviewNotif (cb) {
    if (!this.socket) return (true)

    const rs = JSON.parse(localStorage.getItem('webapp_shell_kanggo'))
    if (!rs) return
    const socketEmit = `notifpreview-${rs.user.id}-${rs.user.roles[0].name}`

    this.socket.on(socketEmit, msg => {
      return cb(msg)
    })
  }

  getNotif (cb) {
    if (!this.socket) return (true)

    const rs = JSON.parse(localStorage.getItem('webapp_shell_kanggo'))
    const socketEmit = `notif-${rs.user.id}-${rs.user.roles[0].name}`

    this.socket.on(socketEmit, msg => {
      return cb(msg)
    })
  }

  getGroupChatUnreadTotal (cb, onReconnect) {
    if (!this.socket) this.setupSocketConnection()
    if (!this.socket) return (true)

    this.removeGroupChatUnreadTotal()

    const rs = JSON.parse(localStorage.getItem('webapp_shell_kanggo'))
    const userId = rs && rs.user ? rs.user.id : null
    const roleName = rs && rs.user && rs.user.roles && rs.user.roles[0] ? rs.user.roles[0].name : null
    if (!userId || !roleName) return

    this.groupChatUnreadEvent = `group-chat-unread-total-${userId}-${roleName}`
    this.groupChatUnreadHandler = msg => cb(msg)
    this.socket.on(this.groupChatUnreadEvent, this.groupChatUnreadHandler)

    if (onReconnect) {
      this.groupChatUnreadDisconnectHandler = () => {
        this.groupChatWasDisconnected = true
      }
      this.groupChatUnreadConnectHandler = () => {
        if (!this.groupChatWasDisconnected) return

        this.groupChatWasDisconnected = false
        onReconnect()
      }
      this.socket.on('disconnect', this.groupChatUnreadDisconnectHandler)
      this.socket.on('connect', this.groupChatUnreadConnectHandler)
    }
  }

  removeGroupChatUnreadTotal () {
    if (!this.socket) return

    if (this.groupChatUnreadEvent && this.groupChatUnreadHandler) {
      this.socket.off(this.groupChatUnreadEvent, this.groupChatUnreadHandler)
    }
    if (this.groupChatUnreadConnectHandler) {
      this.socket.off('connect', this.groupChatUnreadConnectHandler)
    }
    if (this.groupChatUnreadDisconnectHandler) {
      this.socket.off('disconnect', this.groupChatUnreadDisconnectHandler)
    }

    this.groupChatUnreadEvent = null
    this.groupChatUnreadHandler = null
    this.groupChatUnreadConnectHandler = null
    this.groupChatUnreadDisconnectHandler = null
    this.groupChatWasDisconnected = false
  }

  disconnect () {
    if (this.socket) {
      this.removeGroupChatUnreadTotal()
      this.socket.disconnect()
      this.socket = null
    }
  }
}

export default new SocketioService()
